
import React from "react";
import PuttingScoreButtons from "./PuttingScoreButtons";
import ChippingScoreButtons from "./ChippingScoreButtons";
import WedgingScoreButtons from "./WedgingScoreButtons";
import BunkerScoreButtons from "./BunkerScoreButtons";
import IronScoreButtons from "./IronScoreButtons";
import FairwayWoodScoreButtons from "./FairwayWoodScoreButtons";
import DriverScoreButtons from "./DriverScoreButtons";
import GreenAttackScoreButtons from "./GreenAttackScoreButtons";

interface ScoringButtonsRendererProps {
  isPutting: boolean;
  isChipping: boolean;
  isWedging: boolean;
  isBunker: boolean;
  isIron: boolean;
  isFairwayWood: boolean;
  isDriver: boolean;
  isGreenAttack: boolean;
  currentLevel: number;
  currentPoint: string;
  onScoreChange: (score: number, tendency?: any) => void;
  testId?: string;
}

const ScoringButtonsRenderer: React.FC<ScoringButtonsRendererProps> = ({
  isPutting,
  isChipping,
  isWedging,
  isBunker,
  isIron,
  isFairwayWood,
  isDriver,
  isGreenAttack,
  currentLevel,
  currentPoint,
  onScoreChange,
  testId
}) => {
  if (isPutting) {
    return <PuttingScoreButtons onScoreChange={onScoreChange} />;
  }

  if (isChipping) {
    return <ChippingScoreButtons onScoreChange={onScoreChange} />;
  }

  if (isWedging) {
    return <WedgingScoreButtons onScoreChange={onScoreChange} />;
  }

  if (isBunker) {
    return <BunkerScoreButtons onScoreChange={onScoreChange} />;
  }

  if (isGreenAttack) {
    return <GreenAttackScoreButtons onScoreChange={onScoreChange} />;
  }

  if (isIron) {
    return <IronScoreButtons onScoreChange={onScoreChange} />;
  }

  if (isFairwayWood) {
    return <FairwayWoodScoreButtons onScoreChange={onScoreChange} />;
  }

  if (isDriver) {
    return <DriverScoreButtons onScoreChange={onScoreChange} testId={testId} />;
  }

  return null;
};

export default ScoringButtonsRenderer;
